module.exports = __webpack_public_path__ + "img/Renewing Forgotten Flows_new.18e2f32f.jpg";